import React, { useRef, useEffect } from "react";
import { StyleSheet, Text, View, Dimensions, Animated } from "react-native";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "../../../../Utils/responsive";
import "../../../../App.scss";
import {
  experience,
  experienceIntroText,
  buttonText,
} from "../../../../Utils/static-strings";
import "./intro-page.css";
import ContinueButton from "../../../../Components/ContinueButton";
import clockIcon from "../../../../assets/images/clock-regular-full.svg";

const deviceWidth = Dimensions.get("screen").width;

const Index = (props) => {
  const imageOpacity = useRef(new Animated.Value(0)).current;
  const imageSize = Math.min(430, deviceWidth * 0.35);

  const animation = useRef(
    new Animated.Value(-Dimensions.get("screen").width)
  ).current;

  useEffect(() => {
    Animated.parallel([
      Animated.timing(animation, {
        toValue: 0,
        duration: 1000,
        useNativeDriver: false,
      }),
      Animated.timing(imageOpacity, {
        toValue: 1,
        duration: 800,
        useNativeDriver: false,
      }),
    ]).start();
  }, []);

  return (
    <div
      style={{
        height: "100%", // deviceWidth > 600 ? '85vh' : '88vh',
        width: "100%",
        // flex: 1,
        position: "absolute",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Animated.View
        style={{
          width: deviceWidth > 600 ? "82%" : "90%",
          height: "75%",
          justifyContent: "center",
          // marginBottom: deviceWidth > 600 ? '13%' : deviceWidth < 374 ? '25%' : '35%',
          transform: [{ translateX: animation }],
        }}
      >
        <Text
          style={{
            fontFamily: "var(--font-family-heading)",
            fontSize: deviceWidth > 768 ? 60 : deviceWidth > 320 ? 48 : 40,
            lineHeight: deviceWidth > 768 ? 68 : deviceWidth > 320 ? 52 : 48,
            fontWeight: "var(--font-weight-semi-bold)",
            color: "var(--text-color-default)",
            marginBottom: hp("4%"),
          }}
        >
          {experience}
        </Text>
        <Text style={styles.customText}>
          {experienceIntroText}
          {/* {deviceWidth < 600 ? experienceIntroTextMobile : experienceIntroText} */}
          {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis quam felis, accumsan eget pulvinar eu, tincidunt a quam.
                    {"\n"}{"\n"}
                    Duis felis nulla, consectetur a eros eget, suscipit tempus velit. Sed nec purus sit amet odio dignissim tristique. Fusce eu semper tellus, sit amet euismod magna. */}
        </Text>
        <View
          style={{
            flexDirection: "row",
            marginBottom: hp("3%"),
            height: 18,
          }}
        >
          <img
            src={clockIcon}
            alt=""
            style={{ width: 18, height: 18, objectFit: "contain" }}
          />
          <Text
            style={{
              fontSize: 14,
              fontFamily: "var(--font-family-default)",
              color: "var(--text-color-default)",
              paddingLeft: 10,
            }}
          >
            Typically 2 minutes
          </Text>
        </View>
        <ContinueButton
          onClick={() => props.setDisplay(false)}
          text={buttonText}
        />
      </Animated.View>
      <View style={{ height: "25%", width: "100%" }} />
      <Animated.Image
        source={require("../../../../assets/images/mandg/mandg-active-square-exp.png")}
        style={{
          position: "absolute",
          bottom: 0,
          right: 0,
          width: imageSize,
          height: imageSize,
          resizeMode: "contain",
          pointerEvents: "none",
          opacity: imageOpacity,
        }}
      />
    </div>
  );
};
export default Index;
const styles = StyleSheet.create({
  content: {
    height: "100vh", // deviceWidth > 600 ? '85vh' : '88vh',
    width: "100vw",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },

  customText: {
    width:
      Dimensions.get("screen").width > 1300
        ? Dimensions.get("screen").width > 1400
          ? wp("56%")
          : wp("60%")
        : Dimensions.get("screen").width > 700
          ? wp("60%")
          : wp("89%"),
    fontSize: 19,
    textAlign: "Left",
    color: "var(--text-color-default)",
    marginBottom: hp("3%"),
    fontFamily: "var(--font-family-default)",
    lineHeight: 24,
    alignSelf: "flex-start",
  },
});
